const src = import.meta.ROLLUP_FILE_URL_U6muqRGa8aHtq8t0c9wAzg;
export default {
  src,
  srcSet: src + " " + 1536 + "w",
  width: 1536,
  height: 1024,
};